
import "./contact.scss";
import { Person, Mail,GitHub, LinkedIn } from "@material-ui/icons";


export default function Contact() {

  return (
    <div className="contact" id="contact">
      <div className="left">
        <img src="assets/t-rex.svg" alt="" />
      </div>
      <div className="right">
        <h2>Contact Me:</h2>
        <br/>
        <div className="infoContainer">
        <div className="itemContainer">
        <Person className="icon" /> <span>(510) 695-6462 </span> 
        </div>
        

        <div className="itemContainer">    
        <GitHub className="icon"/> 
        <a href="https://github.com/raguerraa"> 
        <span>raguerraa </span>
        </a>
        </div>

        <div className="itemContainer"> 
        <LinkedIn className="icon"/> 
        <a href="https://www.linkedin.com/in/ronald-guerra-a3519a165/">    
        <span>Ronald Guerra </span>
        </a>
        </div>
        

        <div className="itemContainer">  
        <Mail className="icon"/> <span>angel3322ronald@gmail.com</span>     
        </div>
        </div>
    
      </div>
    </div>
  );
}